import { render, staticRenderFns } from "./RibbonSection.vue?vue&type=template&id=27b59db7&scoped=true&lang=pug"
import script from "./RibbonSection.vue?vue&type=script&lang=js"
export * from "./RibbonSection.vue?vue&type=script&lang=js"
import style0 from "./RibbonSection.styl?vue&type=style&index=0&id=27b59db7&prod&lang=stylus&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b59db7",
  null
  
)

export default component.exports